import config from "@/app/config.js";
import { getApiUrl } from "@/services/_apiUrl";
import * as submissionService from "@/services/submissionService";

const state = {
  submissionDetails: null,
  isSubmissionDataLoading: false,
  activeFace: {},
  selectedFaces: [],
  legacySubmissionDetails: null,
};

const getters = {
  getSubmissionDetails: (state) => state.submissionDetails,
  getLegacySubmissionDetails: (state) => state.legacySubmissionDetails,
  isSubmissionDataLoading: (state) => state.isSubmissionDataLoading,
  isVideoSubmission: (state) => {
    return state.submissionDetails?.medias?.length && state.submissionDetails?.medias[0]?.media_type === "video";
  },
  getActiveFace: (state) => state.activeFace,
  getSelectedFaces: (state) => state.selectedFaces,
};

const mutations = {
  setSubmissionDetails: (state, payload) => {
    state.submissionDetails = payload;
  },
  setSubmissionDataLoading: (state, payload) => {
    state.isSubmissionDataLoading = payload;
  },
  updateSubmissionStatusAndTasks: (state, payload) => {
    if (state.submissionDetails) {
      state.submissionDetails.status = payload.status;
      state.submissionDetails.result = payload.result;
      state.submissionDetails.tasks = payload.tasks;
      state.submissionDetails.summary = payload.summary;
    }
  },
  setActiveFace: (state, payload) => {
    state.activeFace = payload;
  },
  setSelectedFaces: (state, payload) => {
    state.selectedFaces = payload;
  },
};

const actions = {
  async fetchSubmissionDetails({ commit }, params) {
    const isDevMode = config.VITE_APP_DEV_MODE === "on";
    const fromPdf = params.fromPdf || false;
    const pollMode = params.pollMode || false;
    const allow404 = params.allow404 || false;
    const { id, queryParams } = params;

    try {
      if (!fromPdf && !pollMode) {
        commit("setSubmissionDetails", null);
        commit("setSelectedFaces", []);
        commit("setActiveFace", {});
      }

      const apiUrl = getApiUrl();
      let url = `${apiUrl.submission.GET.DETAIL}${id}/`;

      if (queryParams) {
        url += queryParams;
      }

      if (isDevMode) {
        url += "?generate_signed_urls=true";
      }

      const response = await submissionService.fetchSubmissionDetails(url, { allow404 });

      if (pollMode) {
        commit("updateSubmissionStatusAndTasks", {
          status: response.data.status,
          result: response.data.result,
          tasks: response.data.tasks,
          summary: response.data.summary,
        });
      } else if (!fromPdf) {
        commit("setSubmissionDetails", response.data);
      }

      return response.data;
    } catch (error) {
      console.error("Error fetching submission details:", error);

      throw error;
    }
  },
  setActiveFace({ commit }, payload) {
    commit("setActiveFace", payload);
  },
  setSelectedFaces({ commit }, payload) {
    commit("setSelectedFaces", payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
